import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import { Link } from '@reach/router';
import React from 'react';
import styled, { css } from 'styled-components/macro';
import {
  focusRing,
  fontSize,
  fontWeight,
  layout,
  lineHeight,
  media,
  neutral,
  radius,
  shadow,
  space,
  transition,
} from '../../../theme/tokens';

export const CardList = styled.ul`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: ${space[4]};
  margin: 0;
  padding: 0 ${layout.gutter};
  list-style: none;

  ${media.md`
    grid-template-columns: repeat(auto-fill, minmax(30rem, 1fr));
    gap: ${space[5]};
    max-width: ${layout.contentMaxWidth};
    margin: 0 auto;
    padding: 0 ${layout.gutterWide};
  `}
`;

export const Card = styled.li`
  position: relative;
  margin: 0;
  padding: ${space[5]};
  border-radius: ${radius.lg};
  box-shadow: ${shadow.md};
  list-style: none;
  text-align: left;
  background-color: ${({ theme }) => theme.classroomHighlight};
  color: ${({ theme }) =>
    theme.isClassRoomDark ? theme.textLight : theme.headerColour};
  transition: box-shadow ${transition.normal}, transform ${transition.normal};

  &:hover {
    box-shadow: ${shadow.lg};
  }

  ${({ lesson }) =>
    lesson &&
    css`
      background-color: ${({ theme }) => theme.lessonHighlight};
      color: ${({ theme }) =>
        theme.isLessonDark ? theme.textLight : theme.headerColour};
    `}

  ${({ isTarget }) =>
    isTarget &&
    css`
      background-color: ${({ theme }) => theme.targetHighlight};
      color: ${({ theme }) =>
        theme.isTargetDark ? theme.textLight : theme.headerColour};
    `}

  ${({ isAssessment }) =>
    isAssessment &&
    css`
      background-color: ${({ theme }) => theme.targetHighlight};
      color: ${({ theme }) =>
        theme.isTargetDark ? theme.textLight : theme.headerColour};
    `}

  ${({ isCategory }) =>
    isCategory &&
    css`
      padding: ${space[3]} ${space[4]};
      background-color: ${neutral.subtle};
      color: ${({ theme }) => theme.headerColour};
      box-shadow: none;
      border: 1px solid ${neutral.border};
    `}
`;

export const CardWithImage = styled(Card)`
  display: flex;
  align-items: center;
  gap: ${space[4]};

  ${({ hasNotifications }) =>
    hasNotifications &&
    css`
      width: 100%;
    `}
`;

export const ModuleCardWithImage = styled(CardWithImage)`
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  gap: ${space[4]};
  height: 100%;
`;

export const ProgressContainer = styled.div`
  width: 100%;
`;

export const UnstyledLink = styled(Link)`
  color: inherit;
  text-decoration: inherit;
  border-radius: ${radius.md};
  ${focusRing}
`;

export const CategoryButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 ${layout.gutter} ${space[5]};
  padding: 0;

  ${media.md`
    max-width: ${layout.readableMaxWidth};
    margin: 0 auto ${space[5]};
  `}
`;

export const HomeCardHeader = styled.h3`
  margin: 0;
  font-weight: ${fontWeight.bold};
  font-size: ${fontSize.xl};
  line-height: ${lineHeight.tight};
  text-align: left;
  overflow-wrap: anywhere;
`;

export const CategoryArrow = (props) => {
  return (
    <SwapHorizIcon
      {...props}
      style={{ fontSize: '1rem', width: '3.2em', height: '3.2em' }}
    ></SwapHorizIcon>
  );
};
